import React from 'react'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Flex,
    Text,
    IconButton,

    /* Hooks */
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import SelectedRefinements from './selected-refinements'

/* Icons */
import { CustomClose } from '../../../components/icons'

const getSelectedFilterCount = (selectedRefinements) => {
    let count = 0

    for (const key in selectedRefinements) {
        if (key === 'cgid' || key === 'htype') continue

        const values = selectedRefinements[key]?.split('|')
        count += values.length
    }

    return count
}

const SelectedFiltersHeader = ({productSearchResult, toggleFilter, resetFilters, onClose}) => {
    const selectedRefinements = productSearchResult?.selectedRefinements || {}
    const numberOfSelectedFilters = getSelectedFilterCount(selectedRefinements)
    const styles = useMultiStyleConfig('PageFilters')

    return (
        <Box {...styles.sfhContainer}>
            <Flex align="center" justify="space-between">
                <Text {...styles.sfhNoFilter}>
                    {numberOfSelectedFilters > 0 ? (
                        <FormattedMessage
                            id="selected_filters_header.filters_selected"
                            defaultMessage="{count, plural, one {# filter selected} other {# filters selected}}"
                            values={{count: numberOfSelectedFilters}}
                        />
                    ) : (
                        <FormattedMessage
                            id="selected_filters_header.none_selected"
                            defaultMessage="No filter selected"
                        />
                    )}
                </Text>
                <IconButton
                    data-testid="filters-button-close"
                    variant={'unstyled'}
                    aria-label="Close"
                    icon={<CustomClose />}
                    {...styles.sfhCloseCTA}
                    onClick={onClose}
                />
            </Flex>

            <SelectedRefinements
                filters={productSearchResult?.refinements}
                toggleFilter={toggleFilter}
                handleReset={resetFilters}
                selectedFilterValues={selectedRefinements}
                spacing={{base: 1, lg: '10px'}}
            />
        </Box>
    )
}

export default SelectedFiltersHeader
